import { useState, useEffect, useContext } from 'react';
import {} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext, SttSCAdminList } from '../../../sporttia/all';
import {
    updateElementInArray,
    deleteElementFromArray,
} from '../../../lib/utils';
import SCAdminDialog from './SCAdminDialog';

type SCAdmin = {
    id: string;
};

export default function AdminsTab(): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [scAdmins, setScAdmins] = useState<SCAdmin[]>();
    const [selectedAdmin, setSelectedAdmin] = useState<
        SCAdmin | Record<string, never>
    >();

    /**
     * Load admins
     */
    const loadAdmins = () => {
        cxt?.api('GET', `/scs/${cxt?.sc?.id}/admins`, {
            success: (r: { rows: SCAdmin[] }) => {
                setScAdmins(r.rows);
            },
        });
    };

    /**
     * SC id changes
     */
    useEffect(() => {
        if (cxt?.sc?.id) loadAdmins();
    }, [cxt?.sc?.id]);

    /**
     * Delete sc admin
     */
    const delSCAdmin = (scAdmin: SCAdmin) => {
        cxt?.api('DELETE', `/scs/admins/${scAdmin.id}`, {
            confirmation: true,
            success: () => {
                cxt?.showMessage('S', t('Deleted'));
                setScAdmins(deleteElementFromArray(scAdmins || [], scAdmin));
            },
        });
    };

    // -----| Render |-----
    return (
        <>
            <SttSCAdminList
                scAdmins={scAdmins ?? ([] as any)}
                onCreate={() => setSelectedAdmin({})}
                onDelete={delSCAdmin as any}
                onSelect={
                    ((scAdmin: SCAdmin) => setSelectedAdmin(scAdmin)) as any
                }
            />

            <SCAdminDialog
                scAdmin={selectedAdmin}
                onClose={
                    ((adminUpdated: SCAdmin) => {
                        // Close popup
                        setSelectedAdmin(undefined);

                        if (adminUpdated.id) {
                            setScAdmins(
                                updateElementInArray(
                                    scAdmins || [],
                                    adminUpdated,
                                ),
                            );
                        }
                    }) as any
                }
            />
        </>
    );
}
